import Vue from 'vue'
import Vuex from 'vuex'
import track from './modules/track'

import('../utils/app').then(app => {
  Vuex.Store.prototype.$toast = app.default.toast
})
Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
    pageError: false,
    showMenu: false, // 是否显示常驻悬浮菜单
    authCode: '' // 小程序登录后生成的authCode
  },
  modules: {
    track
  },
  mutations: {
    SET_PAGEERROR_STATE(state, { status, title }) {
      state.pageError = status
      state.pageTitle = title
    },
    SET_SHOW_MENU(state, showMenu) {
      state.showMenu = showMenu
    }
  },
  actions: {
    setPageErrorState({ commit }, { status, title }) {
      commit('SET_PAGEERROR_STATE', { status, title })
    },
    setShowMenu({ commit }, showMenu) {
      commit('SET_SHOW_MENU', showMenu)
    }
  }
})
